import React, { useMemo } from 'react';
import { StationeryTemplateCategoryEnum } from '@graphql/generated-base';
import { useRouteMatch } from '@react-router';
import { getStationeryTemplateCategoryFromNamedCategoryPath, isValidShopPageMatch, useCardsRouterContext } from '@apps/card/Card.routes';
import { CardCategoryContextProvider, useCardCategoryContext } from '@apps/card/components/CardCategoryProvider';

/**
 * Temporary until we have explicit routes per card category.
 * Derives current category from the gallery route URL.
 */
export const CardCategoryProvider: React.FC = ({ children }) => {
  const { routes } = useCardsRouterContext();
  const shopRouteMatch = useRouteMatch({ path: routes.designsGallery.paths });

  const currentCategory = useMemo(() => {
    if (shopRouteMatch && isValidShopPageMatch(shopRouteMatch.params)) {
      return getStationeryTemplateCategoryFromNamedCategoryPath(shopRouteMatch.params.category);
    }

    return StationeryTemplateCategoryEnum.saveTheDate;
  }, [shopRouteMatch]);

  return <CardCategoryContextProvider value={{ currentCategory }}>{children}</CardCategoryContextProvider>;
};

export { useCardCategoryContext };
